import {RouteDefinition} from '../../../routes';
import {LanguageListScreen} from "./LanguageListScreen";

export const LanguageSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/language',
        component: LanguageListScreen,
    },
];
